<template>
    <div class="confirm-overlay" v-if="show">
        <div class="confirm-overlay-content elevation-1">
            <div class="overlay-title" v-if="title && title !== ''">{{title}}</div>
            <div class="overlay-content" v-if="text && text !== ''">
                <!-- eslint-disable vue/no-v-html -->
                <div v-html="text"></div>
                <!--eslint-enable-->
            </div>
            <div class="overlay-actions">
                <v-btn small depressed @click="disagree">
                    Disagree
                </v-btn>
                <v-btn small depressed color="primary" @click="agree">
                    Agree
                </v-btn>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name   : 'ConfirmOverlay',
    props  : {
        show : Boolean,
        title: String,
        text : String
    },
    methods: {
        disagree() {
            this.$emit('disagree')
        },
        agree() {
            this.$emit('agree')
        }
    }
}
</script>
<style lang="scss">
    .confirm-overlay {display: block;position: absolute;left: 0;top: 0;width: 100%;height: auto;min-height: 100%;z-index: 99; background: rgba(237, 240, 245, 0.5);
        .confirm-overlay-content {
            float: left;
            width: 250px;
            left: 50%;
            top: 50%;
            position: absolute;
            z-index: 10;
            background: #fff;
            padding: 10px;
            -moz-transform: translate(-50%, -50%);
            -webkit-transform: translate(-50%, -50%);
            -o-transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
            -webkit-border-radius: 3px;
            -moz-border-radius: 3px;
            border-radius: 3px;
        }
        .overlay-title {display: block;margin: 0 0 10px; font-weight: bold; font-size: 16px;}
        .overlay-actions { text-align: right; display: block; padding: 16px 0 0 0;
            button.v-btn {margin: 0 0 0 10px;}
        }
    }
</style>
